import {
  Flex,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  useDisclosure, IconButton, Box, DrawerFooter,
} from "@chakra-ui/react";
import { AiOutlineMenu } from "react-icons/ai";
import DsrPageSideMenu from "./DsrPageSideMenu";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import DsrProspectSideMenu from '../dsr-prospecting/DsrProspectSideMenu';
import LaunchdeckBrandingLabel from '../../global/components/product-marketing/LaunchdeckBrandingLabel';
import DsrNavigationDrawerMenu from '../../layout/components/sidebar/components/DsrNavigationDrawerMenu';
import { MdDashboard } from 'react-icons/md';
import useChangeSubpageDisplay from '../../global/hooks/change-subpage-display';
import { IoChevronBack } from 'react-icons/io5';


function DsrPageSideMenuDrawer({ 
  selectedDisplayPageId, 
  dsrPropertiesRedux,
  dsrPagesRedux, 
  isProspectPage, 
  isMobileView 
}) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { handleSelectSubpage } = useChangeSubpageDisplay();


  return (
    <>
      <IconButton
        aria-label="Launchdeck Menu Sidebar"
        fontSize="2rem"
        fontWeight='semibold'
        color='#29ABE2'
        icon={<AiOutlineMenu />}
        onClick={onOpen}
        bg='transparent'
      />
      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
      >
        <DrawerOverlay />
        <DrawerContent maxW='17em'>
          <DrawerHeader p="1em 1em 1em 0.5em" bg='brandDark.500' >
            <Flex justify='space-between' align='center'>
              <Flex justify='flex-start' align='center' gap='0.5em'>
              <Box 
                  as={IoChevronBack}
                  aria-label="Room Menu Sidebar back button"
                  color='white'
                  // icon={<IoChevronBack />}
                  onClick={onClose}
                  // bg='#2D3748'
                />
                <Box color='white' fontSize='0.875em'> Room Menu</Box>
              </Flex>
              <DsrNavigationDrawerMenu darkMode={true} icon={<MdDashboard />} />
            </Flex>
          </DrawerHeader>

          <DrawerBody>
            <Box marginLeft='-20px' height='80vh'>
              {isProspectPage ?
                <DsrProspectSideMenu
                  pageArray={dsrPagesRedux}
                  selectedDisplayPageId={selectedDisplayPageId}
                  handleSelectSubpage={handleSelectSubpage}
                  closeMenuDrawer={onClose}
                />
                :
                <DsrPageSideMenu
                  pageArray={dsrPagesRedux}
                  selectedDisplayPageId={selectedDisplayPageId}
                  handleSelectSubpage={handleSelectSubpage}
                  closeMenuDrawer={onClose}
                  altPageNames={dsrPropertiesRedux?.altPageNames}
                />
              }
            </Box>
          </DrawerBody>

          {isMobileView &&
            <DrawerFooter>
              <Flex direction='column' w='100%'>
                <Box>
                  <LaunchdeckBrandingLabel />
                </Box>
              </Flex>
            </DrawerFooter>
          }

        </DrawerContent>
      </Drawer>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    selectedDisplayPageId: state.changeDsrPage.selectedDisplayPageId,
    dsrPagesRedux: state.setDsrPages.pages,
    isMobileView: state.mobileViewMode.isMobileView,
    dsrPropertiesRedux: state.draftDsrProperties.properties,
  }
}


export default withRouter(connect(mapStateToProps, null)(DsrPageSideMenuDrawer))